import { List } from 'immutable'
import * as actions from './actions'
import Driver from './Driver'
import { Record } from '../transit'
import { ListMeta } from '../lib/redux-lists'

const State = Record({
  meta: new ListMeta(),
  all: new List(),
  found: new List(),
  current: new Driver(),
  imported: new List(),
  importErrors: new List()
}, 'drivers')

const driversReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.DRIVERS_LOAD_SUCCESS: {
      const drivers = List(action.payload.data.map(json => new Driver(json)))
      return state.set('all', drivers).set('meta', new ListMeta(action.payload.meta))
    }
    case actions.DRIVERS_SEARCH_SUCCESS: {
      const drivers = List(action.payload.data.map(json => new Driver(json)))
      return state.set('found', drivers)
    }
    case actions.DRIVERS_LOAD_TODAY_ATTENDANCE_SUCCESS: {
      const drivers = List(action.payload.data.map(json => new Driver(json)))
      return state.set('all', drivers).set('meta', new ListMeta(action.payload.meta))
    }
    case actions.DRIVER_LOAD_SUCCESS: {
      const driver = new Driver(action.payload.data)
      return state.set('current', driver)
    }
    case actions.DRIVER_CREATE_SUCCESS: {
      const driver = new Driver(action.payload.data)
      return state.set('current', driver)
    }
    case actions.DRIVERS_IMPORT_SUCCESS: {
      return state.set('imported', List(action.payload.data.map(json => new Driver(json))))
    }
    case actions.DRIVERS_IMPORT_ERROR: {
      return state.set('importErrors', List(action.payload.map(json => new Driver(json))))
    }
    case actions.DRIVER_UPDATE_SUCCESS: {
      const driver = new Driver(action.payload.data)
      return state.set('current', driver)
    }
    case actions.DRIVER_DELETE_SUCCESS: {
      const list = state.get('all')
      const { _id } = action.payload.data
      const index = list.findIndex((item) => item._id === _id)
      return state.set('all', list.remove(index))
    }
    case actions.CLEAR_DRIVERS: {
      return state.set('all', new List()).set('meta', new ListMeta())
    }
    case actions.CLEAR_FOUND_DRIVERS: {
      return state.set('found', new List())
    }
    case actions.CLEAR_DRIVER: {
      return state.set('current', new Driver())
    }
    default:
      return state
  }
}

export default driversReducer



// WEBPACK FOOTER //
// ./src/common/drivers/reducer.js